import React, { Component } from "react";
import { translate  } from './../../helpers/intl_helpers';

import NormalDataTable from './../NormalDataTable';

class CustomerList extends Component {

	/** Manage table custom render */
	customRender = (actionKey, rowData) => {
		if(!actionKey || !rowData || !rowData._id)  return "";
		let element = "";

		if(actionKey === "message"){
			element = (
				<div dangerouslySetInnerHTML={{ __html: rowData.message }} />
			);
		}
		return element;
	};// end customRender()

	render() {
		let pageStats = {
			tableId :	'notificationList',
			title 	:	translate("notification.notifications"),
			columns :	[
				{name: 	translate("notification.title"), selector: "title", width: "30%", defaultSort: true, sortable: true, direction: "asc"},
				{name: 	translate("notification.message"), selector: "message", width: "30%", sortable: true, customRender: this.customRender },
			],
			search : [
				{name: translate("notification.title"), selector: "title", 	input_type: "text"},
			]
		}

		return <>
			<NormalDataTable pageStats={pageStats} apiParm={{model: 'notification', method: 'getNotifications', is_table_list: true}} />
		</>
	}
}
export default CustomerList;
